import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
export default function SearchAppBar() {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar className="footerpart" position="static" sx={{ boxShadow: 0 }}>
        <Toolbar></Toolbar>
      </AppBar>
    </Box>
  );
}
